import { request } from 'umi';

export async function getReportTypeListApi() {
  return request<API.SystemReportType[]>('/system/report_type');
}
